/** Reservations paid online (gopay_*) cannot be settled or stornoed at the slope. */
export function isPrepaid(paymentMethod) {
    return paymentMethod.startsWith('gopay');
}
/** "3. návštěva" counts the visits behind the child plus the one happening now. */
export function visitLabel(visitsCount) {
    return visitsCount === 0 ? 'První návštěva' : `${visitsCount + 1}. návštěva`;
}
const PAID_METHOD_LABELS = {
    in_place_cash: 'Hotově',
    in_place_card: 'Kartou',
};
/** How the spot was paid, in the words the backoffice payment methods carry. */
export function paidMethodLabel(paymentMethod) {
    if (isPrepaid(paymentMethod)) {
        return 'Zaplaceno předem';
    }
    return PAID_METHOD_LABELS[paymentMethod] ?? 'Zaplaceno';
}
